<template>
    <div class="product">
        <div class="row">
            <div class="col-md-4 col-xl-3">
                <slot name="image"></slot>
            </div>
            <div class="col-md-8 col-xl-9 no-padding">
                <div class="title">
                    <span>{{title}}</span>
                    <span v-if="recommended" class="recommended">{{ $t('Aanbevolen')}}</span>
                </div>
                <p>
                    {{description}}
                </p>
<!--                Hide this button for now until RFT decides to put this button back online-->
<!--                <a :href="linkToWebsite" class="btn default" target="_blank">-->
<!--                    <span>{{ $t('Toon alle info en classificaties')}}</span>-->
<!--                </a>-->

                <div :class="['info-and-qualifications', classesInfoAndQualifications]">
                    <slot name="text"></slot>
                </div>

                <a href="#" @click="toggleDimensions($event)" class="btn default">
                    <span v-show="!isDimensionsActive"><i class="mdi mdi-ruler mr-2"></i>{{ $t('afmetingen') | uppercase }}<i class="mdi mdi-chevron-down ml-2"></i></span>
                    <span v-show="isDimensionsActive"><i class="mdi mdi-ruler mr-2"></i>{{  $t('afmetingen') | uppercase }}<i class="mdi mdi-chevron-up ml-2"></i></span>
                </a>
            </div>
        </div>

        <div class="line-bottom">
            <div :class="['dimensions', classesDimensions]">
                <div class="e-checks green row">
                    <template v-if="isDimensionsActive" v-for="(article, key) in articles">
                        <div class="col-sm-3 no-padding">
                            <checkbox :is-radio-button="true" :product-id="productId" :key="article.sku" name="afmetingen" :is-product-filter="true" :product-img-src="imgSrc" :art-name="article.artName" :sku="article.sku" :id="article.id" :mecs="article.mecs" :diameter="article.diameter" :breedte="article.width" :hoogte="article.height" :price="article.price" :erpCode="article.erpCode"></checkbox>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {EventBus} from '../../services/eventBus';
    import Checkbox from '../../components/elements/Checkbox'
    import InfoRadio from "./RadioFilter";
    import RadioFilter from "./RadioFilter";
    export default {
        name: "product-overview-item",
        props: {
            title: String,
            imgSrc: String,
            description: String,
            recommended: Boolean,
            linkToWebsite: String,
            articles: Array,
            productId: Number
        },
        components: {
            RadioFilter,
            'checkbox': Checkbox
        },
        data() {
            return {
              isDimensionsActive: false,
              isInfoAndQualificationsActive: false,
              selected: null
            };
        },
        computed: {
        classesDimensions() {
          return {
            'is-active': this.isDimensionsActive
          }
        },
        classesInfoAndQualifications() {
          return {
            'is-active': this.isInfoAndQualificationsActive
          }
        }
        },
        methods: {
            openDimensions () {
              this.isDimensionsActive = true;
            },

            closeDimensions () {
              this.isDimensionsActive = false;
              if (this.selected && this.productId === this.selected.productId) {
                EventBus.$emit('selected', {sku: '', id: 0, mecs: '', price: ''});
              }
            },
            toggleDimensions (event) {
              event.preventDefault();
              return (this.isDimensionsActive ? this.closeDimensions() : this.openDimensions());
            },
            openInfoAndQualifications() {
              this.isInfoAndQualificationsActive = true;
            },
            closeInfoAndQualifications() {
              this.isInfoAndQualificationsActive = false;
            },
            toggleInfoAndQualifications(event) {
              event.preventDefault();
              return (this.isInfoAndQualificationsActive ? this.closeInfoAndQualifications() : this.openInfoAndQualifications());
            }
        },
        mounted() {
            EventBus.$on('newPostFilter', function() {
              this.closeDimensions();
              this.closeInfoAndQualifications();
            }.bind(this));

            EventBus.$on('selected', function(value) {
                this.selected = value;
            }.bind(this))

            EventBus.$on('openDimensions', function() {
              this.openDimensions();
            }.bind(this))
        }
    }
</script>

<style scoped>

    div .no-padding {
        margin-top: 0 !important;
    }

</style>



// WEBPACK FOOTER //
// src/components/elements/ProductOverviewItem.vue